import { DefaultPalette, FontSizes, FontWeights } from '@fluentui/react/lib/Styling';
export var getStyles = function (props) {
    var color = props.color, href = props.href, theme = props.theme;
    return {
        root: {
            fill: color,
            cursor: href ? 'pointer' : 'default',
            stroke: DefaultPalette.white,
            outline: 'transparent',
            selectors: {
                '::-moz-focus-inner': {
                    border: '0',
                },
            },
        },
        focusRing: {
            stroke: theme.semanticColors.focusBorder,
            strokeWidth: 4,
            fill: 'transparent',
        },
        arcLabel: {
            fontSize: FontSizes.small,
            fontWeight: FontWeights.semibold,
            fill: theme.palette.neutralPrimary,
        },
    };
};
//# sourceMappingURL=Arc.styles.js.map